import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { COMING_SOON } from "@/lib/assets";

export default function ComingSoon() {
  return (
    <section className="px-6 md:px-12 py-24" data-testid="coming-soon-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-[#3EA65B]">
            More industries on the way
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold tracking-tight text-[#0A0A0A] mt-4">
            Coming soon to Easy Booking.
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mt-5">
            We're rolling out the same effortless booking platform across more service industries.
            Here's what's launching next.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {COMING_SOON.map((item, i) => (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group bg-white border border-gray-100 rounded-3xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              data-testid={`coming-soon-card-${item.name.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full bg-white/90 text-gray-700">
                  <Clock className="h-3.5 w-3.5 text-[#3EA65B]" /> Coming soon
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl font-bold text-[#0A0A0A]">{item.name}</h3>
                <p className="text-gray-600 mt-2 leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
